<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>

            
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="platformGroupName" :formatter="platformGroupProcess" label="公司" width="120"></el-table-column>
                <el-table-column prop="platformName" :formatter="platformProcess" label="平台" width="120"></el-table-column>
                <el-table-column prop="orderSource" :formatter="orderSourceProcess"  label="订单来源"></el-table-column>
                <el-table-column prop="selfMadeType" label="模式" :formatter="selfMadeTypeProcess"></el-table-column>
                <el-table-column prop="saleRule"  label="销售规则" :formatter="saleRuleProcess" sortable  width="180"></el-table-column>
                <el-table-column prop="beginSaleCount"  label="起售数量" sortable  width="80"></el-table-column>
                <el-table-column prop="beginSalePrice"  label="起售金额" sortable  width="180"></el-table-column>
                <el-table-column prop="saleTimes"  :formatter="saleTimesProcess" label="按数量倍数销售" sortable  width="80"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="warning"  size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>


        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台"  clearable filterable :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单来源">
                    <el-select v-model="form.orderSource"  placeholder="订单来源" clearable filterable  :disabled="platformDisabled">
                        <el-option v-for="item in orderSourceData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryKey">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模式">
                    <el-select v-model="form.selfMadeType"  placeholder="模式" clearable filterable  :disabled="platformDisabled">
                        <el-option v-for="item in selfMadeTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售规则">
                    <el-select v-model="form.saleRule"  placeholder="销售规则" clearable filterable  :disabled="platformDisabled">
                        <el-option v-for="item in saleRuleData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="起售数量">
                    <el-input v-model=form.beginSaleCount clearable  placeholder="起售数量"></el-input>
                </el-form-item>
                <el-form-item label="按数量倍数销售">
                    <el-select v-model="form.saleTimes" clearable filterable  placeholder="按数量倍数销售"  >
                        <el-option v-for="item in saleTimesData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="起售金额">
                    <el-input v-model=form.beginSalePrice clearable  placeholder="起售金额"></el-input>
                </el-form-item>



                <el-form-item>

                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getShoppingRule,getShoppingRuleList,deleteShoppingRule,saveShoppingRule,getPlatformList,getValidDictionaryList} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                selfMadeTypeData:[{"id":0,"name":"默认"},{"id":1,"name":"自营"},{"id":2,"name":"福利社"}],
                saleRuleData:[{"id":1,"name":"按数量"},{"id":2,"name":"按金额"}],
                saleTimesData:[{"id":1,"name":"是"},{"id":0,"name":"否"}],
                orderSourceData:[],
                loading:true,
                dialogFormVisible:false,
                form:{"shoppingRuleId":0,"platformId":0,"orderSource":0,"selfMadeType":0,"SaleRule":2,"BeginSaleCount":6,"BeginSalePrice":90,"Sale_Times":0},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled:false,
            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                this.platformData=res.data;
                this.platformData.push({"platformId":0,"platformName":"默认"})
                this.form.platformId=res.data[0].platformId;
                //初始化首页数据

            });
            getValidDictionaryList({dictionaryTypeId:14}).then((res) => {
                //console.log(res.data.value.list);
                if(res.data.success){
                    this.orderSourceData = res.data.value.list;
                    this.orderSourceData.push({"dictionaryKey":-1,"dictionaryName":"默认"});
                    this.getList();
                }

            });

        },
        methods:{
            getList(){
                getShoppingRuleList().then((res) => {
                    this.loading = false;
                    this.listData = res.data.ruleListVos;
                    //this.orderSourceData=res.data.orderSource;
                    //this.platformData=res.data.platFormList;
                    //this.mediaData=res.data.mediaList;
                    //this.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if(confirm("确定删除吗？")) {
                    deleteShoppingRule({shoppingRuleId: row.shoppingRuleId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }

            },
            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.shoppingRuleId=0;
                this.platformDisabled=false;
                //this.handleEdit(d);
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getShoppingRule({shoppingRuleId:data.shoppingRuleId}).then((res) => {
                    //console.log(res.data);
                    if(res.data=undefined) {
                        this.form = res.data;
                    }

                });
            },
            save(data){
                saveShoppingRule(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList();
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },

            platformGroupProcess(row, column, cellValue){
                if(cellValue==""||cellValue==null){
                    return "默认";
                }else{
                    return cellValue;
                }
            },
            platformProcess(row, column, cellValue) {
                if(cellValue==""||cellValue==null){
                    return "默认";
                }else{
                    return cellValue;
                }
                //return this.randData.name;

            },
            orderSourceProcess(row, column, cellValue) {
                for(var key in this.orderSourceData){
                    console.log(this.orderSourceData[key].dictionaryKey+"=="+cellValue);
                    if(this.orderSourceData[key].dictionaryKey==cellValue) {
                        return this.orderSourceData[key].dictionaryName;
                    }
                }
            },
            selfMadeTypeProcess(row,column,cellValue){
                for(var key in this.selfMadeTypeData){
                    if(this.selfMadeTypeData[key].id==cellValue) {
                        return this.selfMadeTypeData[key].name;
                    }
                }
            },
            saleRuleProcess(row,column,cellValue){
                for(var key in this.saleRuleData){
                    if(this.saleRuleData[key].id==cellValue) {
                        return this.saleRuleData[key].name;
                    }
                }
            },
            saleTimesProcess(row,column,cellValue){
                for(var key in this.saleTimesData){
                    if(this.saleTimesData[key].id==cellValue) {
                        return this.saleTimesData[key].name;
                    }
                }
            },



        }
    }

</script>



// WEBPACK FOOTER //
// src/views/sales/shoppingRuleList.vue